const customJSSelectors = {};
class customJS {
    constructor() {
        const styleTag = document.createElement("style");
        styleTag.innerHTML = `#app-embed {
                width:100%;
            }
            section._formHeader_cit2d_24 {
                margin:0 !important;
            }
            #form-container-ref ._formError_1mxsl_21{
                font-family: Plus Jakarta Sans !important;
                font-size: 13px !important;
            }

            #form-container-ref form._formFieldset_cit2d_82 > ._selectContainer_12thd_6{
                margin-bottom: 8px !important;
            }
            #form-container-ref form._formFieldset_cit2d_82 > ._formFieldContainer_1mxsl_5,
            #form-container-ref form._formFieldset_cit2d_82 > ._formPhoneInputContainer_piv1u_6{
                margin-bottom: 8px !important;
                margin-top: 12px !important;   
            }
            #form-container-ref form._formFieldset_cit2d_82 > ._selectContainer_12thd_6 + ._formFieldContainer_1mxsl_5{
                margin-bottom: 0px !important;
            }
            #form-container-ref{
                padding: 20px !important;
                border-radius: 10px !important;
                border: 1px solid #c3d0de !important;
            }
        
            #form-container-ref h2 {
                font-family: Plus Jakarta Sans;
                font-size: 20px;
                font-style: normal;
                font-weight: 700;
                line-height: 130%;
                margin-bottom: 20px !important;
            }
            @media (min-width: 768px) {
                #form-container-ref h2 {
                    font-size: 22px;
                }
                #form-container-ref{
                    padding: 30px 28px !important;
                }
            }
            @media (min-width: 1025px) {
                #form-container-ref h2 {
                    font-size: 25px;
                }
            }
            #form-container-ref section[data-sizing="form-wrapper"] {
                max-width: 100% !important;
                margin: 0;
            }
            #form-container-ref ._label_12thd_10 {
                font-family: Plus Jakarta Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                line-height: 160%; 
                margin-bottom: 10px;
            }

            #form-container-ref input,
            #form-container-ref textarea {
                border-radius: 0;
                border-bottom: 1px solid #D2DCE6;
                box-shadow: none;
                padding: 10px 10px 10px 10px;
                height:100%; 
                font-family: Plus Jakarta Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px; 
                color: #333;
                transition: all 0.3s ease-in-out !important;
            }
            #form-container-ref textarea {
                height: 22px !important;
                overflow: hidden !important;
            }
            #form-container-ref input:hover,
            #form-container-ref textarea:hover{
                border-color: #103959 !important;
            }
            #form-container-ref label._formInputFieldLabel_1mxsl_38 {
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 160%; 
                font-family: Plus Jakarta Sans !important;
                color: #474747;
                text-transform: capitalize !important;
                transform: none !important;
                background-color: #FFF !important;
            }
            #form-container-ref input:focus + label,
            #form-container-ref textarea:focus ~ label {
                top: -1px !important;
                font-size: 10px !important;
                line-height: 15px !important;
                left: 10px !important;
                font-family: Plus Jakarta Sans !important;
                transform:  none !important;
            }
            #form-container-ref input:focus,
            #form-container-ref textarea:focus{
                padding-bottom: 6px !important;
                padding-top: 14px !important;
            }

            #form-container-ref div._formFieldContainer_1mxsl_5:has(label._inputFilled_1mxsl_74) input,
            #form-container-ref div._formFieldContainer_1mxsl_5:has(label._inputFilled_1mxsl_74) textarea {
                padding-bottom: 5px !important;
                padding-top: 15px !important; 
                border-color: #103959 !important;
            }
           
            #form-container-ref input + label._inputFilled_1mxsl_74,
            #form-container-ref textarea ~ label._inputFilled_1mxsl_74 {
                top: -1px !important;
                font-size: 10px !important;
                line-height: 15px !important;
                left: 10px !important;
            }
            #form-container-ref form._formFieldset_cit2d_82 {
                gap: 0 !important;
                padding: 0 !important;
            }

            #form-container-ref input:not(:focus) + label:not(._inputFilled_1mxsl_74) {
                top: 8px !important;
                left: 10px !important;
            }
            #form-container-ref ._formDisclaimer_cit2d_38{
                color: #333 !important;
                font-family: Plus Jakarta Sans !important;
                font-size: 13px !important;
                font-style: normal !important;
                font-weight: 400 !important;
                line-height: 20px !important; 
                margin-top: 25px !important;
            }
            #form-container-ref button._formSubmitButton_cit2d_96{
                color: #1F1D1D !important;
                text-align: center !important;
                font-family: Plus Jakarta Sans !important;
                font-size: 15px !important;
                font-style: normal !important;
                font-weight: 600 !important;
                line-height: 24px !important;
                letter-spacing: 0.75px !important;
                text-transform: uppercase !important;
                transition: all 0.3s ease-in-out !important;
                border-radius: 100px !important;
                padding: 12px 20px !important;
                margin-top: 17px !important;
            }
            #form-container-ref button._formSubmitButton_cit2d_96:hover{
                background-color: #D3E9FB !important;
            }
            button._selectToggle_12thd_25{
                border-radius: 10px !important;
                border: 1px solid #E1E7EF !important;
                box-shadow: none !important;
                background: #FFF !important;
                padding: 8px 15px 8px 15px !important;
                color: #333 !important;
                font-family: Plus Jakarta Sans !important;
                font-size: 16px !important;
                font-style: normal !important;
                font-weight: 400 !important;
                line-height: 25px !important; 
            }
            ._formFieldContainer_1mxsl_5:has(textarea)::before{ 
            display: none !important;
            }
            #form-container-ref textarea ~ label{
                top: 9px !important;
                left: 10px !important;
            }
            #form-container-ref input:-webkit-autofill,
            #form-container-ref input:-webkit-autofill:hover, 
            #form-container-ref input:-webkit-autofill:focus, 
            #form-container-ref input:-webkit-autofill:active,
            #form-container-ref textarea:-webkit-autofill,
            #form-container-ref textarea:-webkit-autofill:hover, 
            #form-container-ref textarea:-webkit-autofill:focus, 
            #form-container-ref textarea:-webkit-autofill:active{
            -webkit-background-clip: text !important;
            -webkit-text-fill-color: #333 !important;
            transition: background-color 5000s ease-in-out 0s !important;
            }
            #form-container-ref input:-internal-autofill-selected,
            #form-container-ref textarea:-internal-autofill-selected{
                background-color: #FFF !important;
            }

        `
        let shadowInterval = setInterval(() => {
            const appEmbed = document.querySelector('[data-forms-id="forms-root-402907"] #app-embed');
            if (!appEmbed?.shadowRoot) return;
            const shadow = appEmbed.shadowRoot;
            if (!shadow.contains(styleTag)) {
                shadow.appendChild(styleTag);
                const container = document.querySelector('[data-forms-id="forms-root-402907"]');
                if (container) container.setAttribute('data-styled', 'true');
            }
            const groupBlock = document.querySelector('body[data-suffix="wholesale-login"] #MainContent .custom-section .row > .group-block > .group-block:last-child');
            if (groupBlock) groupBlock.setAttribute("style", "display: flex !important;");
            clearInterval(shadowInterval);
        }, 10);
    }
}
typeof customJS !== 'undefined' && new customJS();